import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { getResourceTo } from 'react/utils/chatUtils';
import arrow from 'static/images/chat/arrow-down.svg';
import ActionButtons from './actionButtons';


const TicketActions = ({
  ticket,
  setTicketActionsIsOpen,
  toggleChatWindow
}) => {
  const [containerIsOpen, setContainerIsOpen] = useState(false);

  function toggleActionsContainer() {
    setContainerIsOpen((prevState) => !prevState);
    setTicketActionsIsOpen((prevState) => !prevState);
  }

  return (
    <>
      <div className={`ticketActions ${containerIsOpen && 'containerIsOpen'}`}>
        <div className="ticketActionsHeader" onClick={toggleActionsContainer}>
          <div className="ticketActionsTitle">
            {getResourceTo('Greenmile.Chat.TicketActions.Title')}
          </div>
          <span className="toggleContainer">
            <img src={arrow} alt="" />
          </span>
        </div>
        <div className="ticketActionsContainer">
          <div className="info">
            <p>
              <b>
                {`${getResourceTo('Greenmile.Chat.TicketActions.OpeningDate')}: `}
              </b>
              {Monet.Format.DateTime.formatToLocale(ticket.get('createdDate'))}
            </p>
            <p>
              <b>{`${getResourceTo('stop.route')}: `}</b>
              {ticket.get('routeKey')}
            </p>
            <p>
              <b>{`${getResourceTo('stop')}: `}</b>
              {ticket.get('stopDescription')}
            </p>
          </div>
          <ActionButtons
            ticket={ticket}
            toggleChatWindow={toggleChatWindow}
          />
        </div>
      </div>
    </>
  );
};

TicketActions.propTypes = {
  ticket: PropTypes.object.isRequired,
  toggleChatWindow: PropTypes.func.isRequired,
  setTicketActionsIsOpen: PropTypes.func.isRequired
};


export default TicketActions;
